const appStyles = {
    // Header styles
    header: {
        appBar: {
            position: 'static',
            component: 'nav',
        },
        toolbar: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: 'background.default',
        },
        logo: {
            width: 40,
            height: 40,
        },
        searchBoxContainer: {
            flexGrow: 1,
            position: 'relative',
            borderRadius: 1,
            backgroundColor: 'background.paper',
            '&:hover': {
                backgroundColor: 'background.default',
            },
            width: '100%',
            maxWidth: 500,
            margin: 'auto',
            height: '36px',
        },
        searchIcon: {
            padding: '0 8px',
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            color: 'text.primary',
        },
        inputBase: {
            ml: 1,
            flex: 1,
            color: 'text.primary',
        },
        iconButtonContainer: {
            display: 'flex',
            gap: 1,
            alignItems: 'center',
            
        },
        icon: {
            fontSize: 32,
            color: 'primary.dark',
        },
    },

    // Button styles
    button: {
        primary: {
            backgroundColor: 'primary.main',
            color: 'white',
            '&:hover': {
                backgroundColor: 'primary.dark',
            },
        },
        secondary: {
            backgroundColor: 'secondary.main',
            color: 'white',
            '&:hover': {
                backgroundColor: 'secondary.dark',
            },
        },
    },

    // Card styles
    card: {
        container: {
            padding: 2,
            borderRadius: 1,
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
        },
        content: {
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
        },
    },

    // Common layout styles
    layout: {
        centerContent: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        flexColumn: {
            display: 'flex',
            flexDirection: 'column',
        },
        flexRow: {
            display: 'flex',
            flexDirection: 'row',
        },
    },
};

export default appStyles;
